import {
  SUBMIT_CLAIM_REQUEST,
  SUBMIT_CLAIM_SUCCESS,
  SUBMIT_CLAIM_FAILURE,
  RESET_CLAIM_STATE,
} from "../actions/types";

const initialState = {
  isSubmitting: false,
  successMessage: null,
  errorMessage: null,
};

const claimReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUBMIT_CLAIM_REQUEST:
      return {
        ...state,
        isSubmitting: true, // Show loader
        successMessage: null,
        errorMessage: null,
      };

    case SUBMIT_CLAIM_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        successMessage: action.payload,
      };

    case SUBMIT_CLAIM_FAILURE:
      return {
        ...state,
        isSubmitting: false, // Hide loader
        errorMessage: action.payload, // Set error message
      };
    case RESET_CLAIM_STATE:
      return {
        ...state,
        successMessage: null,
        errorMessage: null,
      };

    default:
      return state;
  }
};

export default claimReducer;
